import React, { useRef } from 'react';
var VeltActivityLogListItemContentTarget = function (props) {
    var defaultCondition = props.defaultCondition, activityRecord = props.activityRecord, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-list-item-content-target", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "activity-record": activityRecord }, children));
};
export default VeltActivityLogListItemContentTarget;
